export interface ProjectKnowledgeBadge {
  tag: string
  label: string
  className: string
}

const CLAIMS: Array<[string, string]> = [
  ['risk_or_exception', 'Risco / exceção'],
  ['problem_or_opportunity', 'Problema / oportunidade'],
  ['rule_or_control', 'Regra / controle'],
  ['responsibility', 'Responsabilidade'],
  ['process', 'Processo'],
  ['data_or_metric', 'Dado / métrica'],
  ['system_or_integration', 'Sistema / integração'],
  ['business_object', 'Objeto de negócio'],
  ['event', 'Evento'],
  ['objective_or_result', 'Objetivo / resultado'],
  ['identity', 'Identidade'],
]

const EVIDENCE: Record<string, string> = {
  reported: 'Relatado',
  observed: 'Observado',
  data_confirmed: 'Confirmado por dados',
  contested: 'Contestado',
  superseded: 'Substituído',
  unknown: 'Evidência incerta',
}

const DECISIONS: Record<string, string> = {
  recorded: 'Decisão registrada',
  proposed: 'Decisão proposta',
  considered: 'Decisão em avaliação',
}

export function projectKnowledgeBadges(tags: string[] | undefined): ProjectKnowledgeBadge[] {
  if (!tags?.length) return []
  const values = new Set(tags)
  const badges: ProjectKnowledgeBadge[] = []
  const claim = CLAIMS.find(([value]) => values.has(`claim_kind:${value}`))
  if (claim) badges.push(badge(`claim_kind:${claim[0]}`, claim[1], 'bg-muted text-muted-foreground'))

  const evidence = Object.entries(EVIDENCE).find(([value]) => values.has(`evidence_state:${value}`))
  if (evidence) badges.push(badge(`evidence_state:${evidence[0]}`, evidence[1], evidenceTone(evidence[0])))

  const decision = Object.entries(DECISIONS).find(([value]) => values.has(`decision_state:${value}`))
  if (decision) badges.push(badge(`decision_state:${decision[0]}`, decision[1], decisionTone(decision[0])))
  return badges
}

export function isProjectKnowledgeProfileTag(tag: string): boolean {
  return /^(ontology_family|claim_kind|evidence_state|assertion_mode|decision_state):/.test(tag)
}

function badge(tag: string, label: string, className: string): ProjectKnowledgeBadge {
  return { tag, label, className }
}

function evidenceTone(value: string): string {
  if (value === 'data_confirmed') return 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300'
  if (value === 'contested' || value === 'superseded') return 'bg-rose-500/10 text-rose-700 dark:text-rose-300'
  if (value === 'observed') return 'bg-amber-500/10 text-amber-700 dark:text-amber-300'
  return 'bg-sky-500/10 text-sky-700 dark:text-sky-300'
}

function decisionTone(value: string): string {
  if (value === 'recorded') return 'bg-violet-500/10 text-violet-700 dark:text-violet-300'
  if (value === 'proposed') return 'bg-amber-500/10 text-amber-700 dark:text-amber-300'
  return 'bg-muted text-muted-foreground'
}
